export default class Invoice {
    constructor() {
        this.Invoice = document.getElementById("fv_checkbox_fv");
        this.Receipt = document.getElementById("fv_checkbox_receipt");
        this.inputNIP = document.getElementById("vat_number_field");
        this.inputCompanyName = document.getElementById("billing_company_field");

        if (this.Invoice) {
            this.events();
        }
    }

    events() {
        this.inputNIP.style.display = "none";
        this.inputCompanyName.style.display = "none";

        window.addEventListener("DOMContentLoaded", this.showFields.bind(this));

        this.Invoice.addEventListener("input", this.showFields.bind(this));
        this.Receipt.addEventListener("input", this.showFields.bind(this));
    }

    showFields() {
        if (this.Invoice.checked == true) {
            this.inputNIP.style.display = "block";
            this.inputCompanyName.style.display = "block";
        }

        if (this.Receipt.checked == true) {
            this.inputNIP.style.display = "none";
            this.inputCompanyName.style.display = "none";
        }
    }
}
